import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/stock-locations/$id/')({});
